export default function TopHead() {
  return (
    <div className="w-full h-10 bg-blue-sky-gradient2 hidden md:hidden lg:block py-2 ">
      <div className="flex items-center justify-center text-white lg:items-center lg:justify-center lg:text-center">
        <p> Đăng ký với chúng tôi và nhận tư vấn sản phẩm hoàn toàn miễn phí</p>
      </div>
    </div>
  );
}
